import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

const ForgetPassword = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const onSubmitForgetPass = async (data) => {

    setOtpOptionShow(true)

  };
  const [otp, setOTP] = useState(['', '', '', '']);

  const [otpOptionShow, setOtpOptionShow] = useState(false);
  const inputRefs = useRef([]);


  const handleChange = (index, value) => {

    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);


    if (value !== '' && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };


  const handleBackspace = (index, event) => {
    if (event.key === 'Backspace' && index > 0 && otp[index] === '') {
      inputRefs.current[index - 1].focus();
    }
  };


  const renderInputs = () => {
    const inputs = [];
    for (let i = 0; i < otp.length; i++) {
      inputs.push(
        <input
          key={i}
          ref={el => (inputRefs.current[i] = el)} // Store reference to input element
          type="text"
          maxLength="1"
          value={otp[i]}
          onChange={e => handleChange(i, e.target.value)}
          onKeyDown={e => handleBackspace(i, e)}
          className='w-[48px] h-[48px] rounded border bg-transparent outline-none py-2 px-4 text-[#636363] font-medium'
        />
      );
    }
    return inputs;
  };
  return (
    <div>

      <div className="max-w-[1512px] px-12 w-full mx-auto flex  sm:justify-start justify-center items-center mt-6 min-h-[calc(100vh-184px)]">


        <div className='max-w-[382px] sm:max-w-[563px] w-full p-8 border-none rounded-md bg-white'>
          {
            otpOptionShow ?

              <div className='w-full'>
                <div className='flex gap-1 items-center mb-7 ml-[-4px] cursor-pointer' onClick={() => setOtpOptionShow(false)}>
                  <div className='max-w-[24px] w-full h-6'>
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15 18L9 12L15 6" stroke="#7D7D7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <p className='text-[#7D7D7D] font-rubik uppercase'>Back</p>
                </div>
                <p className='text-[24px] font-bebas uppercase mb-6 leading-8'>A four-digit OTP has been dispatched to your email/phone number please enter OTP Here</p>
                <div className='w-full'>

                  <div className='max-w-[334px] sm:max-w-[499px] w-full'>


                    <div className='flex items-center gap-4'>
                      {renderInputs()}


                    </div>
                  </div>



                  <button onClick={() => navigate("/new-password")} className='my-6 max-w-[132px] w-full h-[44px] rounded-md text-white bg-[#A46E40] text-xl font-bebas leading-5'> Continue</button>

                  <p className='text-base sm:text-xl font-rubik leading-7 text-black'>
                    Please <span className='text-[#A57C52] cursor-pointer hover:underline'>Click Here</span> if you dont recive the OTP and repeat the process again.
                  </p>
                </div>
              </div>
              : <div className='w-full'>
                <div className='flex gap-1 items-center mb-7 ml-[-4px] cursor-pointer' onClick={goBack}>
                  <div className='max-w-[24px] w-full h-6'>
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15 18L9 12L15 6" stroke="#7D7D7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <p className='text-[#7D7D7D] font-rubik uppercase'>Back</p>
                </div>
                <p className='text-[32px] font-bebas uppercase mb-6 '>Forget Password</p>
                <form onSubmit={handleSubmit(onSubmitForgetPass)} className='w-full'>

                  <div className='max-w-[334px] sm:max-w-[499px] w-full'>
                    <p className='font-montserrat text-sm sm:text-base leading-8 font-medium pb-2 text-black'>Enter Email Address Or Phone Number</p>
                    <input type="email" className='w-full h-[48px] text-[#636363] font-medium rounded border bg-transparent outline-none py-2 px-4'

                      {...register("email", {
                        required: {
                          value: true,
                          message: "Enter Your Email",
                        },

                      })}
                    />

                    <label className="label">
                      {errors.email?.type === "required" && (
                        <span className="label-text-alt text-red-600">
                          {errors?.email?.message}
                        </span>
                      )}

                    </label>
                  </div>



                  <input className='my-6 max-w-[132px] w-full h-[44px] rounded-md text-white bg-[#A46E40] text-xl font-bebas leading-5 cursor-pointer' type='submit' value="Continue" />
                </form>
              </div>


          }



        </div>
      </div>

    </div>
  );
};

export default ForgetPassword;